
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/beta-restricted",
      function () {
        return require("private-next-pages/auth/beta-restricted.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/beta-restricted"])
      });
    }
  